import React from 'react';
import styles from './index.module.css';

const CheckIcon = () => (
  <svg className={styles.check} viewBox='0 0 12 12' fill='none' aria-hidden='true'>
    <path d='M2 6.5L4.75 9L10 3.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

const CheckboxPill = ({ name, value, label, checked, onChange }) => (
  <label className={checked ? `${styles.label} ${styles.checked}` : styles.label}>
    <input
      type='checkbox'
      className={styles.input}
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange(value)}
    />
    <span className={styles.box}>
      <CheckIcon />
    </span>
    <span className={styles.text}>{label}</span>
  </label>
);

export default CheckboxPill;
